import { TeamSelector } from './team-selector'
import { useHallUsers } from '@/contexts/HallUsersProvider'
import { SpeakingRole, Turn, TurnType } from '@db8/shared'

export const UserSelector = ({
  turn,
  isSelectDisabled,
}: {
  turn: Turn
  isSelectDisabled: boolean
}) => {
  const { hallUsers } = useHallUsers()

  // Slot belongs to a team: only team members are eligible for selection.
  // Bots must be assigned to a team (speakingRole) via Participant Panel to appear here.
  const hasAffirmativeUsers = hallUsers.some((user) => user.speakingRole === SpeakingRole.Affirmative)
  const hasNegativeUsers = hallUsers.some((user) => user.speakingRole === SpeakingRole.Negative)

  if (!hasAffirmativeUsers || !hasNegativeUsers) {
    return null
  }

  return (
    <div>
      {turn.type === TurnType.Affirmative && (
        <TeamSelector
          step={turn.step}
          isSelectDisabled={isSelectDisabled}
          speakingRole={SpeakingRole.Affirmative}
          defaultUserId={turn.primarySpeakerId}
          position="primary"
        />
      )}
      {turn.type === TurnType.Negative && (
        <TeamSelector
          step={turn.step}
          isSelectDisabled={isSelectDisabled}
          speakingRole={SpeakingRole.Negative}
          defaultUserId={turn.primarySpeakerId}
          position="primary"
        />
      )}
      {(turn.type === TurnType.AffirmativeCrossNegative ||
        turn.type === TurnType.NegativeCrossAffirmative) && (
        <>
          {/* Directed cross-ex: Slot 1 questions Slot 2.
              AxN => Aff questions Neg
              NxA => Neg questions Aff */}
          {turn.type === TurnType.NegativeCrossAffirmative ? (
            <>
              <div className="py-2">
                <TeamSelector
                  step={turn.step}
                  isSelectDisabled={isSelectDisabled}
                  speakingRole={SpeakingRole.Negative}
                  defaultUserId={turn.primarySpeakerId}
                  position="primary"
                />
              </div>
              <div className="py-2">
                <TeamSelector
                  step={turn.step}
                  isSelectDisabled={isSelectDisabled}
                  speakingRole={SpeakingRole.Affirmative}
                  defaultUserId={turn.secondarySpeakerId}
                  position="secondary"
                />
              </div>
            </>
          ) : (
            <>
          <div className="py-2">
            <TeamSelector
              step={turn.step}
              isSelectDisabled={isSelectDisabled}
              speakingRole={SpeakingRole.Affirmative}
              defaultUserId={turn.primarySpeakerId}
              position="primary"
            />
          </div>
          <div className="py-2">
            <TeamSelector
              step={turn.step}
              isSelectDisabled={isSelectDisabled}
              speakingRole={SpeakingRole.Negative}
              defaultUserId={turn.secondarySpeakerId}
              position="secondary"
            />
          </div>
            </>
          )}
        </>
      )}
    </div>
  )
}
